import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { FiShoppingCart, FiMenu, FiX, FiUser, FiLogOut } from 'react-icons/fi';

const Navbar = () => {
  const { user, logout, cartCount } = useApp();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

        {/* Logo */}
        <Link to="/" className="text-2xl font-bold text-primary">
          Téranga <span className="text-secondary">Mode</span>
        </Link>

        {/* Menu Desktop */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-gray-700 hover:text-primary font-medium transition">
            Accueil
          </Link>
          <Link to="/catalogue" className="text-gray-700 hover:text-primary font-medium transition">
            Catalogue
          </Link>
          {user && (
            <Link to="/mes-commandes" className="text-gray-700 hover:text-primary font-medium transition">
              Mes commandes
            </Link>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-4">
          <Link to="/panier" className="relative">
            <FiShoppingCart size={24} className="text-gray-700 hover:text-primary transition" />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-secondary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                {cartCount}
              </span>
            )}
          </Link>

          {user ? (
            <div className="flex items-center gap-3">
              <div className="hidden md:flex items-center gap-2 text-gray-700">
                <FiUser size={18} />
                <span className="font-medium">{user.name}</span>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition text-sm"
              >
                <FiLogOut size={16} />
                <span className="hidden md:block">Deconnexion</span>
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link
                to="/login"
                className="text-primary font-medium hover:underline text-sm"
              >
                Connexion
              </Link>
              <Link
                to="/register"
                className="bg-secondary text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition text-sm"
              >
                Inscription
              </Link>
            </div>
          )}

          {/* Menu Mobile */}
          <button
            className="md:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Menu Mobile Dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-4">
          <Link to="/" onClick={() => setMenuOpen(false)} className="text-gray-700 font-medium">Accueil</Link>
          <Link to="/catalogue" onClick={() => setMenuOpen(false)} className="text-gray-700 font-medium">Catalogue</Link>
          {user && (
            <Link to="/mes-commandes" onClick={() => setMenuOpen(false)} className="text-gray-700 font-medium">Mes commandes</Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;